export default __webpack_public_path__ + "static/media/csclogo.ef58e8d0.jpeg";